import React from "react";

const VideoTest = () => {
  return <div>VideoTest</div>;
};

export default VideoTest;
